import { MapGaugesNotifications } from '../../../services/GaugesNotificationService';

export const GET_NOTIFIED_GAUGES = 'get_notified_gauges';

export interface IGetNotifiedGaugesAction {
    type: typeof GET_NOTIFIED_GAUGES;
    payload: MapGaugesNotifications;
}

export type GaugesActions = IGetNotifiedGaugesAction;
